export function getOtherProductsLabel(
    digitalStylingProducts: any,
    showcaseProducts: any,
    stylingProducts: any
): string | null {
    if (
        digitalStylingProducts.length === 0 &&
        showcaseProducts.length === 0 &&
        stylingProducts.length === 0
    ) {
        return null;
    }
    
    if (showcaseProducts.length > 0) {
        return 'orders/create/panel-headings/row-label-additional-products';
    }

    return 'orders/create/panel-headings/row-label-styling';
}

export function groupBy(key: string, array: any[]): object {
    return array.reduce((objectsByKeyValue, obj) => {
        const value = obj[key];
        objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
        return objectsByKeyValue;
    }, {});
}
